import { NgModule } from '@angular/core';
import { DetailedDataComponent } from 'shared/components/detailed-data/detailed-data.component';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { VisitorInfoFieldComponent } from 'shared/components/detailed-data/visitor-info-field/visitor-info-field.component';
import { VisitorInfoFieldBlockComponent } from 'shared/components/detailed-data/visitor-info-field-block/visitor-info-field-block.component';
import { FormsModule } from '@angular/forms';
import { LoadingModule } from 'shared/components/loading/loading.module';
import { VisitorCampaignCriterionComponent } from 'shared/components/detailed-data/visitor-campaign-criterion/visitor-campaign-criterion.component';
import { VisitorCampaignCriterionBlockComponent } from 'shared/components/detailed-data/visitor-campaign-criterion-block/visitor-campaign-criterion-block.component';
import { AutoSaveModule } from 'common/auto-save/auto-save.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgIconModule,
    FormsModule,
    LoadingModule,
    AutoSaveModule
  ],
  declarations: [
    DetailedDataComponent,
    VisitorInfoFieldComponent,
    VisitorInfoFieldBlockComponent,
    VisitorCampaignCriterionBlockComponent,
    VisitorCampaignCriterionComponent
  ],
  exports: [
    DetailedDataComponent,
    VisitorInfoFieldComponent,
    VisitorInfoFieldBlockComponent,
    VisitorCampaignCriterionBlockComponent,
    VisitorCampaignCriterionComponent
  ]
})
export class DetailedDataModule {}
